// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__COHYN","input":"styles_input__3ue8n"};